module.exports = __webpack_public_path__ + "static/media/mwi-logo.a691b609.jpg";